import React from 'react';
export function PainSection() {
  return <section className="bg-gray-50 py-4 md:py-5 px-4" data-id="element-158">
      <div className="max-w-3xl mx-auto" data-id="element-159">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2 text-center" data-id="element-160">
          Si sos docente de Psicología, esto te va a sonar familiar…
        </h2>

        <div className="space-y-2 text-lg text-gray-700" data-id="element-161">
          <div className="bg-white p-3 rounded-lg shadow-sm border-l-4 border-red-400" data-id="element-162">
            <p className="font-medium" data-id="element-163">
              Llegás del colegio agotado/a y todavía tenés que planificar.
            </p>
          </div>

          <div className="bg-white p-3 rounded-lg shadow-sm border-l-4 border-red-400" data-id="element-164">
            <p className="font-medium" data-id="element-165">
              Horas armando clases sobre corrientes psicológicas, procesos
              mentales, adolescencia, identidad, emociones…
            </p>
          </div>

          <div className="bg-white p-3 rounded-lg shadow-sm border-l-4 border-red-400" data-id="element-166">
            <p className="font-medium" data-id="element-167">
              Preparando evaluaciones claras, buscando actividades que realmente
              enganchen, tratando de que los contenidos no queden solo en
              teoría.
            </p>
          </div>
        </div>

        <div className="mt-3 text-center" data-id="element-168">
          <p className="text-xl md:text-2xl font-bold text-gray-800" data-id="element-169">
            No es falta de capacidad. <br className="md:hidden" data-id="element-170" />
            <span className="bg-yellow-200 px-1" data-id="element-171">
              Es que te falta un sistema completo que te sostenga todo el año.
            </span>
          </p>
        </div>
      </div>
    </section>;
}